import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import DownloadNoticeProvider from "@/components/feature/DownloadNoticeProvider";

export default function SiteLayout() {
  return (
    <DownloadNoticeProvider>
      <div className="flex min-h-screen flex-col bg-background-50">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </DownloadNoticeProvider>
  );
}